import _ from "underscore";
import { IBusinessInfo } from "../interface/IBusiness";

export const  formatCurrencyJs =(localLang:string,decimalSeparator:string,country:string) => {
   
    if (decimalSeparator === ',') {
        if (localLang == "fr") {
            localLang = "fr-FR";
        }
        else if (localLang == "pl") {
            localLang = "pl-PL";
        }
        else if (localLang == "de") {
            localLang = "de-DE";
        }
        else if (localLang == "nb") {
            localLang = "no-NO";
        }
        else if (localLang == "nn") {
            localLang = "no-NO";
        }
        else {
            switch (country) {
                case 'COL':
                    localLang = "es-CO";
                    break;
                case 'ARG':
                    localLang = "es-AR";
                    break;
                case 'MEX':
                    localLang = "es-MX";
                    break;
                default:
                    localLang = "es-ES";
                    break;
            }
        }
    }
    else {
        switch (country) {
            case 'NZL':
                localLang = "en-NZ";
                break;
            case 'AUS':
                localLang = "en-AU";
                break;
            case 'CAN':
                localLang = "en-CA";
                break;
            case 'IRL':
                localLang = "en-IE";
                break;
            case 'GBR':
                localLang = "en-GB";
                break;
            default:
                if (localLang == "fr" || localLang == "pl" ||
                    localLang == "de" || localLang == "nb" ||
                    localLang == "nn") {
                    localLang = "en-GB";
                }
                else
                    localLang = "en-US";

                break;
        }
    }

    return localLang;
}


function formatCurrencyOnSaveJs(localLang:string,country:string)  {


    if (localLang == "fr") {
        localLang = "fr-FR";
    }
    else if (localLang == "pl") {
        localLang = "pl-PL";
    }
    else if (localLang == "de") {
        localLang = "de-DE";
    }
    else if (localLang == "nb") {
        localLang = "no-NO";
    }
    else if (localLang == "nn") {
        localLang = "no-NO";
    }
    else if (localLang == "es") {
        switch (country) {
            case 'COL':
                localLang = "es-CO";
                break;
            case 'ARG':
                localLang = "es-AR";
                break;
            case 'MEX':
                localLang = "es-MX";
                break;
            default:
                localLang = "es-ES";
                break;
        }
    }
    else {
        switch (country) {
            case 'NZL':
                localLang = "en-NZ";
                break;
            case 'AUS':
                localLang = "en-AU";
                break;
            case 'CAN':
                localLang = "en-CA";
                break;
            case 'IRL':
                localLang = "en-IE";
                break;
            case 'GBR':
                localLang = "en-GB";
                break;
            default:
                if (localLang == "fr" || localLang == "pl" ||
                    localLang == "de" || localLang == "nb" ||
                    localLang == "nn") {
                    localLang = "en-GB";
                }
                else
                    localLang = "en-US";

                break;
        }
    }
    return localLang;
}


export const setNumber =  (num:number) => {
    return Number(Math.round(Number(num + 'e10')) + 'e-10');
}

export const setNumberOld = (num:number) =>{
    const strNum = num.toFixed(2);
    return parseFloat(strNum);
}

export const computeForVat =  (vat:number) => {
    return (1 + vat / 100);
}

export const computeForNetNumber =  (price:number, vat:number, qty:number, discountRate:number)=> {
    return setNumber(setNumber(qty * price) - (setNumber(qty * price) * discountRate)) / computeForVat(vat);
}


export const computeForGrossNumber =  (price:number, vat:number, qty:number, discountRate:number)=> {
    return setNumber(setNumber(qty * price) + (setNumber(qty * price) * discountRate)) / computeForVat(vat);
}

export const computeForGross =  (price:number, vat:number, qty:number)=> {
    return setNumberOld(setNumber(qty * price) * (1 +  vat/100));
}


export const computeForGrossWithDiscount = (price:number, qty:number, discountRate:number) =>{
    return setNumber(qty * price) - (setNumber(qty * price) * discountRate);
}

export const computeForNetStr =  (gross:number, vat:number, includeCurrency:boolean,localLang:string,country:string,decimalPlaces:number,currency:string)=> {
    const net = computeForNetNumber(gross, vat,0,0);
    localLang = formatCurrencyOnSaveJs(localLang,country);

   

    const valFormatted = net.toLocaleString(localLang, { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
    if (includeCurrency)
        return currency + valFormatted;
    else
        return valFormatted;
}

export const computeForGrossNumberFromNet =  (net:number, vat:number)=> {
    if (!vat)
        return net;

    return setNumber(net * computeForVat(vat));
}


export const setDecimalValWithCurrencyLang =  (val:any,localLang:string,business:IBusinessInfo, isEmpty:boolean)=> {
    if (val==null || isNaN(val)) return '';

    let _tempVal = val;

    if (isNaN(_tempVal)) return '';

    if (_.isString(_tempVal))
        _tempVal = Number(_tempVal);
    if (isEmpty && _tempVal === 0) return '';

    localLang = formatCurrencyJs(localLang,business.numberDecimalSeparator,business.country)

    const valFormatted = _tempVal.toLocaleString(localLang, { minimumFractionDigits: business.decimalPlacesPrice, maximumFractionDigits: business.decimalPlacesPrice });

    if (business.currency)
        return business.currency + '' + valFormatted;

    return valFormatted;
};


export const  setDecimalValWithNoCurrencyLangRevertFromDev =  (val:string, business:IBusinessInfo,localLang:string) => {
    if (!val) return 0;

    const parseNumber = (value:string, locales:any  = navigator.languages) =>{
        const example = Intl.NumberFormat(locales).format(1.1);
        const cleanPattern = new RegExp(`[^-+0-9${example.charAt(1)}]`, 'g');
        const cleaned = value.replace(cleanPattern, '');
        const normalized = cleaned.replace(example.charAt(1), '.');

        return parseFloat(normalized);
    }

    localLang = formatCurrencyJs(localLang,business.numberDecimalSeparator, business.country);
    const _tempVal = parseNumber(val, localLang);

    if (isNaN(_tempVal)) return 0;
    return _tempVal;


};